import React from 'react'

function ReceiptInnerStyle() {
  return (
    <style jsx='true'>
    {`

      #receipt-inner-container {
        display: flex;
      }

      #payment-options-block-container {
        /*padding: 5px;*/
        margin-right: 5px;
        /*background-color: black;*/
        flex: 1.7;
      }

      #paid-by-input-container {
        display: flex;
      }
      #paid-by-input-container label {
        /*flex: 1;*/
        margin-right: 10px;
        padding: 5px;
        font-size: 0.9rem;
      }
      #paid-by-input-container input {
        flex: 2;
        padding: 5px;
        margin-right: 20%;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 0.5px solid black;
        border-radius: 0;
        font-size: 1rem;
        font-weight: bold;
      }

      #payment-options-buttons-container {
        /*background-color: violet;*/
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 15px;
        /*
        grid-column-gap: 15px;
        grid-row-gap: 15px;
        */
        padding: 20px;
        height: 50vh;
        overflow: auto;
      }

      #summary-block-container {
        border: solid 0.5px lightgrey;
        background-color: whitesmoke;
        font-size: 0.85rem;
        flex: 1;
      }

      #select-payment-options-label {
        margin-top: 20px;
        padding: 5px;
        text-align: left;
        font-size: 0.9rem;
        background-color: lightgrey;
        padding: 5px;
      }

      #summary-container-label {
        background-color: yellow;
        color: black
        font-size: 0.85rem;
        font-weight: bold;
        padding: 10px;
        text-align: center;
      }

      .data-container {
        padding: 5px;
        display: flex;
      }
      .summary-data-label {
        flex: 2;
      }
      .summary-data {
        flex: 1;
        text-align: right;
      }
      .summary-data-label, .summary-data {
        padding: 5px;
      }
      .data-container.discounts {
        margin-left: 10px;
        padding-top: 2px;
        padding-bottom: 2px;
      }
      .data-container.discounts .summary-data-label,
      .data-container.discounts .summary-data {
        padding: 0 5px;
      }

      .bold {
        font-weight: bold;
      }

      .close-btn {
        padding-left: 5.5px;
        padding-right: 5.5px;
        padding-top: 4px;
        padding-bottom: 3px;
        border-radius: 50px;
        background-color: red;
        border: none;
        margin: auto;
        font-size: 0.8em;
        color: white;
      }
      .close-btn:hover {
        border: none;
      }
      .close-btn:focus {
        border: none;
      }

      .delete-button-container {
        display: flex;
        justify-content: center;
      }

      .red { color: red; }

      .payment-option-button {
        padding: 30px 10px;
        background-color: rgba(10, 110, 250, 1);
        color: whitesmoke;
      }
      .discounts-btn {
        background-color: rgba(250, 10, 50, 1);
        color: whitesmoke;
      }
      .pospro-action-btn.payment-option-button:hover {
        color: white;
      }

    `}
    </style>
  )
}

export default React.memo(ReceiptInnerStyle)
